export const carrierSpotRequestTableConstants = {
    LOADING: 'SPOTSHIPMENTS_LOADING',
    ERROR: 'SPOTSHIPMENTS_ERROR',
    CLEAR: 'SPOTSHIPMENTS_CLEAR',
    UPDATE_CARRIER_TABLE: 'SPOTSHIPMENTS_UPDATE_CARRIER_TABLE',
    CLOSE_MODAL: 'SPOTSHIPMENTS_CLOSE_MODAL',
    MODAL_LOADING: 'SPOTSHIPMENTS_MODAL_LOADING',
    UPDATE_SELECTED_SHIPMENT: 'SPOTSHIPMENTS_UPDATE_SELECTED_BOOKING',
    SET_INITIAL_STATE: 'SPOTSHIPMENTS_SET_INITIAL_STATE',
}